import {
  actions,
} from '@/store/modules/system-messages/actions';
import {
  getters,
} from '@/store/modules/system-messages/getters';
import {
  mutations,
} from '@/store/modules/system-messages/mutations';
import {
  state,
} from '@/store/modules/system-messages/state';

export const systemMessages = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
